import { ServiceResponseType } from '@/helpers/serviceParsing';
import { useInView } from '@/hooks/customHooks';
import router, { MallMainLoader } from '@/router';
import { getMallAllSellerProduct, getMallId, getMallProductList, ProductListType } from '@/services/mallUser.service';
import { useLazyMallAppBarHeight } from '@/store/lazyMallStore';
import { usePurchaseDrawerStore } from '@/store/purchaseDrawerStore';
import delay from '@/utils/delay';
import { Box, styled, Tab, Tabs } from '@mui/material';
import produce from 'immer';
import { useEffect, useRef, useState } from 'react';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import ProductCard from './ProductCard';
import NoProductListImg from '@/assets/images/product_no_list.jpg'

type ProductListPropType = {
}

function ProductList() {
    /* 👇 초기 UI를 위한 변수 */
    // let { tagNames } = useLoaderData() as MallMainLoader;
    /* 👇 구매 drawer을 위한 변수*/
    const { setIsDrawerOpen, setDrawerProductList } = usePurchaseDrawerStore((state) => state.action);
    const { isDrawerOpen } = usePurchaseDrawerStore(state => state)
    /* 👇 페이지네이션을 위한 변수 */
    const [tabIndex, setTabIndex] = useState(0);
    const [offset, setOffset] = useState(0);
    const [offsetStep, setOffsetStep] = useState(10);
    const [triggerForNextPage, setTriggerForNextPage] = useState('first');
    const [limit, setLimit] = useState(10);
    const [searchTag, setSearchTag] = useState('');
    const [isLastPage, setIsLastPage] = useState(false);

    /* 👇 api 호출 위한 변수 */
    const params = useParams();
    const navigate = useNavigate();
    const [productList, setProductList] = useState([] as ProductListType['productList']);

    /*🚥 👇 method 🚥*/
    /* 👇 tag탭 전환에따라 검색에 필요한 변수 초기화 */
    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
        const tagName = event?.currentTarget?.textContent || '전체';
        setSearchTag(tagName === '전체' ? '' : tagName);
        setOffset(0);
        setProductList([]);
        setIsLastPage(false);
        setTriggerForNextPage('first');
    };


    /* 👇 다음 페이지를 위한 observer 설정
        - 탭 전환 시 옵저버 재설정 */
    const observedTargetForNextPage = useRef<HTMLDivElement>(null);
    const [observeNestPage, unObserveNestPage] = useInView((isObserved) => {
        if (!isObserved) return;
        setTriggerForNextPage(() => new Date().toISOString());
    });
    useEffect(() => {
        observeNestPage(observedTargetForNextPage?.current);
        return () => {
            if (observedTargetForNextPage?.current) {
                unObserveNestPage(observedTargetForNextPage?.current);
            }
        };
    }, [tabIndex]);

    /* 👇 observer가 다음페이지 인식하면 offset, currentTabNum변경 다음 페이지 호출 로직 실행하는 부분 */
    useEffect(() => {
        if (isLastPage || triggerForNextPage === 'first') return;
        (async () => {
            try {
                const { productList: responseProductList, totalCount } = await getMallAllSellerProduct(
                    searchTag,
                    offset,
                    limit,
                );
                if (offset + offsetStep >= totalCount) setIsLastPage(true);
                setOffset((current) => current + offsetStep);
                setProductList(
                    produce((draft) => {
                        responseProductList?.forEach((product) => {
                            draft.push(product);
                        });
                    }),
                );
            } catch (error) {
                const e = error as ServiceResponseType;
                if (e.status === 400) {
                    console.log('상품 없음');
                }
            }
        })();
    }, [triggerForNextPage, tabIndex]);

    /*🚥 👇 Components 🚥*/
    return (
        <>
            <Box flexGrow={1} padding="1% 0">
                <Tabs2 value={tabIndex} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto">
                    {['공구진행중 상품🔥'].map((tagName, i) => (
                        <Tab2 label={tagName} key={tagName + '' + i} />
                    ))}
                </Tabs2>
                <Box display={'grid'} gridTemplateColumns="repeat(2, 1fr)" gap="13px" padding={'0 20px'}>
                    {productList?.map((product, i) => {
                        const {
                            representProductId,
                            productGroupId,
                            representProductImage,
                            representProductName,
                            representProductPrice,
                            inventory,
                            totalCharge,
                            isForSale,
                            discountMethod,
                            discountValue,
                            productShippingPolicy,
                            ownerType,
                            discountPercent,
                            matchingSaleDate,
                            vendorInfo
                        } = product;
                        return (
                            <ProductCard
                                isList
                                key={'productCard' + i}
                                isVendor={ownerType === 'VENDOR'}
                                productImage={representProductImage}
                                isSoldOut={!isForSale ? true : inventory === 0 ? true : false}
                                productName={representProductName}
                                originCost={Number(representProductPrice).toLocaleString() + '원'}
                                discountedCost={Number(totalCharge).toLocaleString() + '원'}
                                vendorState={matchingSaleDate}
                                // percent={discountMethod.toLowerCase() === 'won' ? `${Number(discountValue).toLocaleString()}원` : `${discountValue}%`}
                                percent={`${discountPercent}%`}
                                discountValue={discountValue}
                                handleCartClick={async () => { }}
                                handleProductClick={() => {
                                    navigate(`product-details/${productGroupId}`);
                                }}
                            />
                        );
                    })}
                    {/* {productList.length === 0 && (
                        <ProductCard
                            isList={false}
                            productImage={NoProductListImg}
                            originCost={0}
                            productName={''}
                        />
                    )} */}
                </Box>
            </Box>
            <Box ref={observedTargetForNextPage} />
        </>
    );
}

export default ProductList;

/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */
/* components👇 */

var Tabs2 = styled(Tabs)(() => ({
    position: 'sticky',
    top: `${useLazyMallAppBarHeight() - 8}px`,
    zIndex: '999',
    backgroundColor: 'white',
    flexWrap: 'nowrap',
    padding: '0 3% 15px',
    '& .MuiTabs-indicator': {
        backgroundColor: 'black',
    },
}));

var Tab2 = styled(Tab)(() => ({
    fontWeight: 'normal',
    color: 'black',
    minHeight: '36px',
    fontSize: '15px',
    minWidth: '0',
    padding: '0',
    margin: '0 2%',
    '&:hover': {
        color: 'black',
        opacity: 0.4,
    },
    '&.Mui-selected': {
        color: 'black',
        opacity: 1,
    },
    '&.Mui-focusVisible': {
        color: 'black',
    },
}));
